export class UnsupportedSchemaTypeError extends Error {
  constructor(message) {
    super(`${message} declared in Renderer is not a valid type.`);
    this.name = 'UnsupportedSchemaTypeError';
  }
}

export class SchemaTypeMismatchError extends Error {
  constructor(type = '') {
    super(`Unrecognized type ${type} in the provided JSON Schema.`);
    this.name = 'SchemaTypeMismatchError';
  }
}

export class DataToSchemaTypeMismatchError extends Error {
  constructor(type = '') {
    super(`Type ${type} does not match the provided display schema.`);
    this.name = 'DataToSchemaTypeMismatchError';
  }
}

export class InvalidTimestampFormatError extends Error {
  constructor() {
    super(`Epoch timestamp must be an integer for it to be formatted.`);
    this.name = 'InvalidTimestampFormatError';
  }
}
